import { render, staticRenderFns } from "./list-pre-company.vue?vue&type=template&id=e5eff830"
import script from "./list-pre-company.vue?vue&type=script&lang=js"
export * from "./list-pre-company.vue?vue&type=script&lang=js"
import style0 from "./list-pre-company.vue?vue&type=style&index=0&id=e5eff830&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports